import { render } from "./DentalVeneersPorcelain.vue?vue&type=template&id=079cdab7"
import script from "./DentalVeneersPorcelain.vue?vue&type=script&lang=js"
export * from "./DentalVeneersPorcelain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__